import { useQuery } from 'react-query';
import { RoleService as rs } from '../api/RoleService';

export function useFetchRoles() {
  const { data, error, isLoading } = useQuery('roles', async () => {
    const response = await rs.fetchRoles();
    console.log('response', response);
    return response.rolesList;
  });

  return { data, error, isLoading };
}
